import { render, staticRenderFns } from "./ValuationSettings.vue?vue&type=template&id=128a215a&"
import script from "./ValuationSettings.vue?vue&type=script&lang=js&"
export * from "./ValuationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports